// extracted by mini-css-extract-plugin
export var dropdownContainer = "_53-5";
export var imageContainer = "_53-4";
export var metricsGrid = "_53-2";
export var productDetailContainer = "_53-1";
export var productListContainer = "_53-0";
export var subscriberTableContainer = "_53-3";